<template>

	<div id="notfound">
		<div class="notfound">
			<img class="assistant-photo" src="../assets/meri2.png" alt="AI Assistant Meri">
            <h1 style="color:#0ea2bd;">Meri AI Assistant </h1>
            <p class="assistant-desc"><strong>Your personal assistant during your stay</strong><br>Instant answers, tailored tips, any language, and a direct line to staff when you need it.</p>
            <a href="https://wa.me/385989619668" class="whatsapp-button" target="_blank" rel="noopener">Chat on WhatsApp</a>
            <router-link to="/" class="home-button">Go to Web app</router-link>

		</div>
	</div>


</template>

<script>
export default {
  name: 'Qrcode',
  mounted(){
    const lang = localStorage.getItem('lang')
    if (lang && this.$i18n) {
      this.$i18n.locale = lang
    }
  }
}
</script>
<style scoped>

#notfound {
  position: relative;
  height: 100vh;
  background: #f6f6f6;
}

#notfound .notfound {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
}

.notfound {
  max-width: 767px;
  width: 100%;
  line-height: 1.4;
  padding: 110px 40px;
  text-align: center;
  background: #fff;
  -webkit-box-shadow: 0 15px 15px -10px rgba(0, 0, 0, 0.1);
          box-shadow: 0 15px 15px -10px rgba(0, 0, 0, 0.1);
}

.notfound .notfound-404 {
  position: relative;
  height: 180px;
}

.notfound .notfound-404 h1 {
  font-family: 'Roboto', sans-serif;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  font-size: 165px;
  font-weight: 700;
  margin: 0px;
  color: #262626;
  text-transform: uppercase;
}

.notfound .notfound-404 h1>span {
  color: #00b7ff;
}

.notfound h2 {
  font-family: 'Roboto', sans-serif;
  font-size: 22px;
  font-weight: 400;
  text-transform: uppercase;
  color: #151515;
  margin-top: 0px;
  margin-bottom: 25px;
}

.notfound .notfound-search {
  position: relative;
  max-width: 320px;
  width: 100%;
  margin: auto;
}

.notfound .notfound-search>input {
  font-family: 'Roboto', sans-serif;
  width: 100%;
  height: 50px;
  padding: 3px 65px 3px 30px;
  color: #151515;
  font-size: 16px;
  background: transparent;
  border: 2px solid #c5c5c5;
  border-radius: 40px;
  -webkit-transition: 0.2s all;
  transition: 0.2s all;
}

.notfound .notfound-search>input:focus {
  border-color: #00b7ff;
}

.notfound .notfound-search>button {
  position: absolute;
  right: 15px;
  top: 5px;
  width: 40px;
  height: 40px;
  text-align: center;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
}

.notfound .notfound-search>button>span {
  width: 15px;
  height: 15px;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%) rotate(-45deg);
      -ms-transform: translate(-50%, -50%) rotate(-45deg);
          transform: translate(-50%, -50%) rotate(-45deg);
  margin-left: -3px;
}


@media only screen and (max-width: 767px) {
  .notfound h2 {
    font-size: 18px;
  }
}

@media only screen and (max-width: 480px) {
  .notfound .notfound-404 h1 {
    font-size: 141px;
  }
}

/* Assistant presentation */
.assistant-photo {
  width: 100%;
  max-width: 160px;
  height: auto;
  border-radius: 0;
  display: block;
  margin: 12px auto;
  box-shadow: none;
}

.assistant-desc {
  max-width: 460px;
  margin: 8px auto 0;
  color: #555;
}

.whatsapp-button {
  display: inline-block;
  margin-top: 18px;
  padding: 12px 22px;
  background-color: #25D366;
  color: #fff;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  box-shadow: 0 8px 16px rgba(37, 211, 102, 0.25);
  transition: background-color 0.2s ease, transform 0.05s ease;
}

.whatsapp-button:hover {
  background-color: #1ebe57;
}

.whatsapp-button:active {
  transform: translateY(1px);
}

.home-button {
  display: inline-block;
  margin-top: 18px;
  margin-left: 10px;
  padding: 12px 22px;
  background-color: #0ea2bd;
  color: #fff;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  transition: background-color 0.2s ease, transform 0.05s ease;
}

.home-button:hover {
  background-color: #0b8fa6;
}

.home-button:active {
  transform: translateY(1px);
}

</style>